module.exports = __webpack_public_path__ + "img/accident-icon.26ec7b56.svg";